/**
 * File global.js.
 *
 * Scripts globais do tema em JavaScript vanilla (sem jQuery).
 * Inclui um carrossel leve baseado em scroll-snap que substitui o Slick.
 */

( function() {
	'use strict';

	const onReady = ( fn ) => {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	};

	/**
	 * Carrossel vanilla (scroll-snap) com dots e autoplay. Substitui o Slick.
	 *
	 * @param {HTMLElement} track  Elemento que contém os slides (scroll container).
	 * @param {Array}       slides Lista de slides (filhos diretos do track).
	 * @param {Object}      opts   Opções: { autoplay: ms }.
	 */
	function initCarousel( track, slides, opts ) {
		const autoplay = opts && typeof opts.autoplay === 'number' ? opts.autoplay : 5000;

		if ( ! track || slides.length < 2 ) {
			return;
		}

		let current = 0;

		// Dots de navegação.
		const dots = document.createElement( 'div' );
		dots.className = 'js-carousel-dots';
		slides.forEach( ( slide, i ) => {
			const dot = document.createElement( 'button' );
			dot.type = 'button';
			dot.className = 'js-carousel-dot';
			dot.setAttribute( 'aria-label', 'Ir para o slide ' + ( i + 1 ) );
			dot.addEventListener( 'click', () => goTo( i ) );
			dots.appendChild( dot );
		} );
		track.parentNode.insertBefore( dots, track.nextSibling );

		function update() {
			Array.prototype.forEach.call( dots.children, ( dot, i ) => {
				dot.classList.toggle( '-active', i === current );
			} );
		}

		function goTo( index ) {
			current = ( index + slides.length ) % slides.length;
			track.scrollTo( {
				left: slides[ current ].offsetLeft - track.offsetLeft,
				behavior: 'smooth',
			} );
			update();
		}

		// Mantém o dot ativo em sincronia com rolagem manual / swipe.
		let scrollTimer;
		track.addEventListener( 'scroll', () => {
			window.clearTimeout( scrollTimer );
			scrollTimer = window.setTimeout( () => {
				const idx = Math.round( track.scrollLeft / track.clientWidth );
				if ( idx !== current && idx < slides.length ) {
					current = idx;
					update();
				}
			}, 100 );
		}, { passive: true } );

		update();

		// Autoplay com pausa no hover.
		if ( autoplay ) {
			let timer = window.setInterval( () => goTo( current + 1 ), autoplay );
			track.addEventListener( 'mouseenter', () => window.clearInterval( timer ) );
			track.addEventListener( 'mouseleave', () => {
				timer = window.setInterval( () => goTo( current + 1 ), autoplay );
			} );
		}
	}

	const slidesOf = ( parent, selector ) =>
		Array.prototype.slice.call( parent.querySelectorAll( selector ) );

	onReady( () => {
		// Carrossel de banners da home.
		const bannerHome = document.querySelector( '.banner-home .container-fluid' );
		if ( bannerHome ) {
			initCarousel( bannerHome, slidesOf( bannerHome, '.row-banner' ), {} );
		}

		// Carrossel de posts em destaque (home do blog).
		const carrossel = document.querySelector( '.carrossel-banners' );
		if ( carrossel ) {
			initCarousel( carrossel, slidesOf( carrossel, '.banner-item' ), {} );
		}

		// Busca: abrir.
		document.querySelectorAll( '.ico-search' ).forEach( ( el ) => {
			el.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				const box = document.getElementById( 'search-box' );
				if ( box ) {
					box.classList.add( '-open' );
				}
				document.body.classList.add( 'blocked' );
				window.setTimeout( () => {
					const input = document.getElementById( 'search' );
					if ( input ) {
						input.focus();
					}
				}, 500 );
			} );
		} );

		// Busca: fechar.
		document.querySelectorAll( '#search-box a[href="#close"]' ).forEach( ( el ) => {
			el.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				document.body.classList.remove( 'blocked' );
				const box = document.getElementById( 'search-box' );
				if ( box ) {
					box.classList.remove( '-open' );
				}
			} );
		} );

		// Menu mobile: abrir/fechar.
		document.querySelectorAll( '.menu-toggle, .icon-close' ).forEach( ( el ) => {
			el.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				document.body.classList.toggle( 'menu-opened' );
				document.body.classList.toggle( 'blocked' );
			} );
		} );

		// Vídeo "sobre nós": play ao clicar.
		document.querySelectorAll( '.video-sobre-nos' ).forEach( ( el ) => {
			el.addEventListener( 'click', () => {
				if ( typeof el.play === 'function' ) {
					el.play();
				}
			} );
		} );

		// Filtro mobile: alterna visibilidade.
		document.querySelectorAll( '.toggle-filter' ).forEach( ( el ) => {
			el.addEventListener( 'click', () => {
				document.querySelectorAll( '.input-control-mobile' ).forEach( ( ctrl ) => {
					ctrl.classList.toggle( 'd-none' );
					ctrl.classList.toggle( 'd-block' );
				} );
			} );
		} );
	} );
}() );
